import styled from 'react-emotion';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import theme, { colors } from '@ublend-npm/aulaui-next-web/themes/default';

export const Container = styled('div')`
  color: ${colors.purple3};
  font-weight: ${theme.font.weight.semiBold};
  font-size: ${theme.font.size.copy};
  line-height: 16px;

  cursor: pointer;

  display: inline-flex;
  align-items: center;
`;

export const Icon = styled(ChevronLeftIcon)`
  font-size: ${theme.font.size.headline};
`;
